/** 분석용 복귀 목적지. 원본 query를 포함한 URL은 이벤트에 남기지 않는다. */
export const getReturnTo = (destination?: string) => {
  if (!destination) return 'default';
  if (!destination.startsWith('/')) return 'external';

  const pathname = destination.split('?')[0];
  if (pathname.startsWith('/play')) return 'play';
  if (pathname.startsWith('/build')) return 'build';
  if (pathname.startsWith('/quiz')) return 'quiz_detail';
  if (pathname.startsWith('/profile')) return 'profile';
  if (pathname.startsWith('/public')) return 'public';

  return 'other';
};

const TRIAL_SOURCES = new Set([
  'signup',
  'profile_edit',
  'banner_modal',
  'header',
  'verification_phone',
  'build',
  'quizWorksheet',
  'detail_locked_quiz',
  'aiBuilder',
  'paidMap',
  'play',
  'play_show_plan_popup',
  'lms',
  'public_sidebar',
  'public_header',
  'public_header_profile_menu',
  'product_header',
  'product_header_profile_menu',
  'classroom_student_list',
  'classroom_student_detail',
  'profile_plan_management',
  'aiTutor',
  'aiTranslation',
  'nextQuizset',
  'isPublic',
  'match',
  'order',
  'quizDetail',
  'play_jelly_shortage',
  'play_jelly_exhausted',
  'play_jelly_info',
]);

/** URL query로 들어온 임의 값을 분석 이벤트나 복귀 URL에 보존하지 않는다. */
export const normalizeTrialSource = (source: unknown) =>
  typeof source === 'string' && TRIAL_SOURCES.has(source) ? source : 'unknown';
